module.exports = __webpack_public_path__ + "img/tlf_sum5.d7a5a872.png";